import { render, staticRenderFns } from "./OrdersHeader.vue?vue&type=template&id=1e7a47fc&"
import script from "./OrdersHeader.vue?vue&type=script&lang=ts&"
export * from "./OrdersHeader.vue?vue&type=script&lang=ts&"
import style0 from "./OrdersHeader.vue?vue&type=style&index=0&id=1e7a47fc&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports